__turbopack_context__.v({
  "route": "RouteState-module-scss-module__4WVavW__route",
  "selected": "RouteState-module-scss-module__4WVavW__selected",
});
